import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoAutomattic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 234 48"
    {...props}
  >
    <g clipPath="url(#Logo_Automattic_svg__a)">
      <path
        fill="#3499CD"
        d="M85.096 34.085c-5.929 0-9.775-4.275-9.775-8.724v-.551c0-4.525 3.846-8.724 9.775-8.724s9.808 4.2 9.808 8.724v.551c0 4.45-3.846 8.724-9.808 8.724m6.636-9.228c0-3.243-2.356-6.127-6.636-6.127-4.279 0-6.598 2.89-6.598 6.127v.405c0 3.243 2.357 6.184 6.598 6.184 4.242 0 6.636-2.941 6.636-6.184z"
      />
      <path
        fill="#010101"
        d="m18.11 33.43-2.21-4.148H6.067L3.914 33.43H.615l9.049-16.74h2.616l9.2 16.74zm-7.216-13.475-3.643 7.042h7.414zm24.862 14.13c-6.01 0-8.8-3.27-8.8-7.616v-9.78h3.12v9.827c0 3.092 2.036 4.93 5.906 4.93 3.973 0 5.604-1.838 5.604-4.93v-9.827h3.143v9.766c0 4.161-2.64 7.63-8.974 7.63m26.468-14.78v14.14H59.08v-14.14h-7.314v-2.616h17.773v2.616zm60.68 14.125V20.182l-.829 1.46-7.013 11.783h-1.532l-6.937-11.782-.83-1.461V33.43h-3.068V16.69h4.35l6.598 11.485.783 1.414.777-1.414 6.537-11.486h4.299V33.43zm26.898 0-2.215-4.148h-9.822l-2.135 4.148h-3.299l9.049-16.74h2.611l9.176 16.74zm-7.216-13.475-3.643 7.042h7.414zm23.25-.65v14.14h-3.139v-14.14h-7.315v-2.616h17.768v2.616zm23.051 0v14.14h-3.143v-14.14h-7.315v-2.616h17.778v2.616zm15.058 14.125V18.273c1.254 0 1.758-.679 1.758-1.584h1.344V33.43zm27.699-12.014a9.75 9.75 0 0 0-6.688-2.69c-4.473 0-6.989 3.067-6.989 6.258v.325c0 3.168 2.54 6.127 7.215 6.127a9.8 9.8 0 0 0 6.561-2.69l1.885 1.983a12.5 12.5 0 0 1-8.672 3.356c-6.334 0-10.18-4.124-10.18-8.648v-.552c0-4.524 4.199-8.8 10.331-8.8 3.544 0 6.763 1.485 8.483 3.342zm-146.16.878-2.878 4.459a1.216 1.216 0 0 0 .361 1.681l.004.002a1.214 1.214 0 0 0 1.681-.361l2.88-4.459a1.216 1.216 0 0 0-.363-1.68l-.004-.003a1.217 1.217 0 0 0-1.681.361"
      />
    </g>
    <defs>
      <clipPath id="Logo_Automattic_svg__a">
        <path
          fill="#fff"
          d="M.615 0h233v48h-233z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoAutomattic;
